var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable react/require-default-props */
import React from 'react';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import { translate } from '@utils/i18n';
import { showSuccessToast, showErrorToast } from '@ui';
import useUpdateDeficiencyDetail from '../../hooks/useUpdateDeficiency';
import ResolveModalForm from './ResolveModalForm';
import useDeficiencyDetail from '../../hooks/useDeficiencyDetail';
import { namespace } from '../../DeficiencyShow/constants';
function ResolveModal({ toggleDialog, deficiencyId, onFinish }) {
    var _a, _b, _c;
    const { data: deficiency, isLoading } = useDeficiencyDetail(deficiencyId);
    const { updateDeficiency: { mutateAsync: updateDeficiency } } = useUpdateDeficiencyDetail();
    const onSubmit = (_a) => __awaiter(this, [_a], void 0, function* ({ deficiencyResolutionStatus, resolutionNotes, resolvedTechnicianName, dateResolved }) {
        try {
            yield updateDeficiency({
                id: deficiencyId,
                deficiencyUpdate: {
                    deficiencyResolutionStatus,
                    resolutionNotes: resolutionNotes !== null && resolutionNotes !== void 0 ? resolutionNotes : '',
                    resolvedTechnicianName: resolvedTechnicianName !== null && resolvedTechnicianName !== void 0 ? resolvedTechnicianName : '',
                    isResolved: true,
                    dateResolved: (dateResolved || new Date()).toISOString()
                }
            });
            showSuccessToast('Deficiency resolved successfully');
            onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        }
        catch (error) {
            console.error('Failed to update deficiency:', error);
            const errorMessage = error instanceof Error ? error.message : translate('error_message_updating', { namespace });
            showErrorToast(errorMessage);
        }
    });
    const resolutionValues = {
        deficiencyResolutionStatus: (_a = deficiency === null || deficiency === void 0 ? void 0 : deficiency.deficiencyResolutionStatus) !== null && _a !== void 0 ? _a : null,
        resolutionNotes: (_b = deficiency === null || deficiency === void 0 ? void 0 : deficiency.resolutionNotes) !== null && _b !== void 0 ? _b : '',
        resolvedTechnicianName: (_c = deficiency === null || deficiency === void 0 ? void 0 : deficiency.resolvedTechnicianName) !== null && _c !== void 0 ? _c : '',
        dateResolved: (deficiency === null || deficiency === void 0 ? void 0 : deficiency.dateResolved) && !Number.isNaN(Date.parse(deficiency.dateResolved))
            ? new Date(deficiency.dateResolved)
            : new Date()
    };
    if (isLoading) {
        return React.createElement(Loader, { size: LoaderSizes.medium });
    }
    return React.createElement(ResolveModalForm, { resolutionValues: resolutionValues, onSubmit: onSubmit, toggleDialog: toggleDialog });
}
export default ResolveModal;
